<div class="p-7">


    <div class="flex justify-between">
        <h4>Editar Itinerário</h4>
        <button mat-icon-button class="btn-close" (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div [formGroup]="form" class="container mx-auto">
        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Local</mat-label>
                <input matInput formControlName="local" />
            </mat-form-field>


            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>CEP</mat-label>
                <input matInput (input)="getAddressByPostalCode()" (blur)="getAddressByPostalCode()"
                    formControlName="postalCode" />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="street" />
            </mat-form-field>

            <!-- Adicione onde preferir no seu formulário -->
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Estado</mat-label>
                <input matInput formControlName="state" />
            </mat-form-field>


            <!-- <div class="flex flex-row w-auto mb-6">
                    <button *ngIf="editIndex === null" mat-flat-button class="btn-tg px-6" (click)="addItemToList()">
                        Adicionar
                    </button>
                    <button *ngIf="editIndex !== null" mat-flat-button color="primary" class="btn-tg px-6"
                        (click)="saveEditAgendaItem()">
                        Salvar Edição
                    </button>
                </div> -->
        </div>

        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Número</mat-label>
                <input matInput formControlName="number" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="neighborhood" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="city" />
            </mat-form-field>
        </div>


        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>País</mat-label>
                <input matInput formControlName="country" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Lagitude</mat-label>
                <input matInput formControlName="latitude" />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="longitude" />
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <div class="flex flex-col justify-center items-start ml-3 gap-3 w-full mt-3">
            <div class="font-bold">Área Tarifário</div>
            <mat-slide-toggle class="input-tg p-bottom-toggle" [checked]="areaTarifarioValue"
                (change)="onAreaTarifarioChange($event)" color="primary" formControlName="areaTarifario">
                <span>
                    {{ areaTarifarioValue ? 'Sim' : 'Não' }}
                </span>
            </mat-slide-toggle>
        </div>

        <div class="flex justify-end gap-4 items-center">
            <button mat-flat-button class="btn-tg" (click)="cancel()">
                Cancel
            </button>
            <button mat-flat-button class="btn-tg" *ngIf="editIndex === null" (click)="editAddress()"
                [disabled]="loading || !form.valid">
                @if(loading){
                <mat-spinner *ngIf="loading" diameter="22" class="loading-spinner"></mat-spinner>
                }@else{
                Salvar
                }
            </button>
        </div>
    </div>


</div>